export const GREEN_CHECK_SERVICES_AMPLIFY_NAME = 'GcvServicesApi';
